module.exports = __webpack_public_path__ + "static/use-case-6-content-2-b-d0f69c6fef64fb73ba1800c2ca45e12a.png";